module.exports = __webpack_public_path__ + "static/media/0.7c8e2ae9.png";